import IframeActivity from "./IframeActivity";

export default function LookAndLearn() {
    return (
        <IframeActivity
            src="/activities/look-and-learn/index.html"
            title="Look and Learn"
        />
    );
}